import { Label } from '@a-ui/react';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { translate } from '../../i18n';

interface DataListProps {
  data?: Record<string, string | number | boolean | undefined>;
}

const DataList: React.FC<DataListProps> = ({ data }) => {
  return (
    <dl className="a-definition-list">
      {data &&
        Object.entries(data).map(([label, value]) => (
          <React.Fragment key={uuidv4()}>
            <dt>{label}</dt>
            <dd>{value || <Label>{translate('common.value.missing')}</Label>}</dd>
          </React.Fragment>
        ))}
    </dl>
  );
};

export default DataList;
